import type { ApiHybrisValidationError, HybrisApiError } from '../clients/hybrisErrorInterceptor';
import type { AxiosException } from '../clients/localApiAxiosErrorInterceptors';

import { appConfig } from '../../../../appConfig';
import { createValidationException } from '../../exceptions/exceptionUtils';
import { isApiHybrisBaseError } from '../clients/hybrisErrorInterceptor';

export const deliveryStoreErrorInterceptor = (
    error: AxiosException<HybrisApiError<ApiHybrisValidationError>>,
) => {
    if (!Array.isArray(error?.response.data.errors)) {
        return null;
    }

    const hybrisErrors = error.response.data.errors;
    if (hybrisErrors.length > 0) {
        const storeNotFoundError = hybrisErrors.find(
            (_error): _error is ApiHybrisValidationError =>
                isApiHybrisBaseError(_error) && _error.type === 'StoreNotFoundError',
        );

        if (storeNotFoundError) {
            return createValidationException(
                appConfig.coopSettings.ecommerce.cart.storeSelectionHomeDeliveryNotSupported,
                'StoreNotFound',
                [
                    {
                        field: 'postalCode',
                        friendlyMessage:
                            appConfig.coopSettings.ecommerce.cart
                                .storeSelectionHomeDeliveryNotSupported,
                        code: 'StoreNotFound',
                    },
                ],
            );
        }
    }

    // pass over to next interceptor
    return null;
};
